<template>
  <div v-for="i in items" :key="i.id" class="b-answer">
    <label>
      <div class="b-answer__wrp">
        <input
          :id="i.id"
          v-model="selectedOption"
          type="radio"
          :value="i.id"
          name="answer"
          @change="$emit('changed-option', i.id)" />
        {{ i.title }}
      </div>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      required: true,
      type: Array,
    },
  },
  emits: ['changed-option'],
  data() {
    return {
      selectedOption: '',
    }
  },

  methods: {},
}
</script>
